"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var checkBoxLocal = function checkBoxLocal(theme) {
  return {
    iconGroup: 'voxi',
    iconName: 'skinny-tick',
    indeterminateIconName: 'skinny-dash',
    borderColor: theme.color.primary3["default"],
    state: {
      checked: {
        backgroundColor: theme.color.success["default"]
      }
    }
  };
};

var _default = checkBoxLocal;
exports["default"] = _default;
//# sourceMappingURL=CheckBox.voxi.theme.js.map